<template>
    <b-container class="pb-2 bg-light mt-2 rounded">
        <page-heading heading="Downloads"/>
        <div role="tablist">
            <!-- Main wrap card -->
            <b-card>
                <!-- Accordion Elements -->
                <b-card no-body class="mb-2" v-for="download_category in download_categories">
                        <b-card-header header-tag="header" role="tab">
                            <b-btn block variant="link" v-b-toggle="'accordion'+download_category.id" class="underline-none pt-0 pb-0 highlight-none">
                                {{download_category.name}}
                            </b-btn>
                        </b-card-header>            
                        <b-collapse :id="'accordion'+download_category.id" accordion="downloads" role="tabpanel">
                            <b-card-body>
                                <b-row>
                                    <b-col cols="12" md="3" sm="6" v-for="download in downloads" v-if="download.category_id == download_category.id">
                                            <a :href="download.path" target="_blank" class="highlight-none underline-none">
                                                <b-card overlay
                                                        :img-src="download.image"
                                                        img-alt="Card Image">
                                                            <!-- <p slot="header" class="font-weight-light text-dark">{{ download.name }}</p> -->
                                                </b-card>
                                            </a>
                                        
                                    </b-col>
                                </b-row>     
                            </b-card-body>
                        </b-collapse>
                </b-card>
            </b-card>
        </div>
    </b-container>
</template>
<script>
import PageHeading from '@/components/SharedComponents/PageHeading.vue'
import axios from 'axios'
export default {
data() {
    return {
        download_categories: [],
        downloads:[]
    }
},
    methods: {
        getDownloadCategories() {
            axios.get(this.API_URL + '/downloads/categories').then((response) => {
                this.download_categories = response.data
            }, (error) => {
                console.log(error)
            })
        },

        getDownloads() {
            axios.get(this.API_URL + '/downloads').then((response) => {
                this.downloads = response.data
            }, (error) => {
                console.log(error)
            })
        }
    },
    components: {
        PageHeading
    },
    beforeCreate() {
        document.title = "Downloads"
    },
    created() {
        
    },
    beforeMount() {
    },
    mounted() {
        this.getDownloadCategories()
        this.getDownloads()
    },
    beforeUpdate() {
        
    },
    updated() {

    }
}
</script>
<style scoped>
    .underline-none{
        text-decoration: none !important;
    }
    .highlight-none{
        outline: none !important;
        box-shadow: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/downloads.vue